import {
    apiRequest,
    jenisDiklatList,
    jenisDiklatActive,
    jenisDiklatInactive,
} from "../../../../../services/adapters/kepegawaian/jenisDiklatService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", jenisDiklatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", jenisDiklatInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", jenisDiklatActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository